import { api, headerBearer } from "./api"

export const getSuppliers = async (token: string) => {
  const response = await api.get(`/suppliers`, headerBearer(token));
  return response.data;
}